import BudgetsKanban from "../../../../components/budgetsKanban";

const BudgetsKanbanPage = (props: any) => {
  return <BudgetsKanban persona="CONSULTANT" {...props} />;
};

export default BudgetsKanbanPage;
